export const references = [
  {
    id: 1,
    src: '/assets/img/reference-01.webp',
    srcSet: '/assets/img/reference-01-700.webp 700w, /assets/img/reference-01-1000.webp 1000w, /assets/img/reference-01.webp 1400w',
    alt: 'Frisch eingebrachte Betonfläche mit Betonpumpenmast',
    caption: 'Betonpumpe im Wohnbau-Einsatz',
    category: 'betonpumpe',
  },
  {
    id: 2,
    src: '/assets/img/reference-02.webp',
    srcSet: '/assets/img/reference-02-700.webp 700w, /assets/img/reference-02.webp 1050w',
    alt: 'Betonpumpe auf einer Baustelle im Rohbau',
    caption: 'Rohbau mit Pumpeneinsatz',
    category: 'betonpumpe',
  },
  {
    id: 3,
    src: '/assets/img/reference-03.webp',
    srcSet: '/assets/img/reference-03-700.webp 700w, /assets/img/reference-03.webp 1050w',
    alt: 'Betonpumpe auf befestigter Baustelle',
    caption: 'Beton einbringen auf engem Raum',
    category: 'betonpumpe',
  },
  {
    id: 4,
    src: '/assets/img/reference-04.webp',
    srcSet: '/assets/img/reference-04-700.webp 700w, /assets/img/reference-04.webp 1050w',
    alt: 'Betonpumpe neben Schalung und Baustellenabsperrung',
    caption: 'Pumpe und Baustellenlogistik',
    category: 'betonpumpe',
  },
  {
    id: 5,
    src: '/assets/img/reference-05.webp',
    srcSet: '/assets/img/reference-05-700.webp 700w, /assets/img/reference-05.webp 1050w',
    alt: 'Betonpumpenfahrzeug von MH-BETON im Einsatz',
    caption: 'Fahrzeug und Technik vor Ort',
    category: 'betonpumpe',
  },
  {
    id: 6,
    src: '/assets/img/reference-06.webp',
    srcSet: '/assets/img/reference-06-700.webp 700w, /assets/img/reference-06.webp 1050w',
    alt: 'Betonpumpe über einer Baugrube mit Absperrung',
    caption: 'Arbeiten an der Baugrube',
    category: 'betonpumpe',
  },
  {
    id: 7,
    src: '/assets/img/reference-07.webp',
    srcSet: '/assets/img/reference-07-700.webp 700w, /assets/img/reference-07.webp 1014w',
    alt: 'Betonpumpenfahrzeug vor einem Rohbau',
    caption: 'Pumpeneinsatz am Rohbau',
    category: 'betonpumpe',
  },
  {
    id: 8,
    src: '/assets/img/reference-08.webp',
    srcSet: '/assets/img/reference-08-700.webp 700w, /assets/img/reference-08.webp 1050w',
    alt: 'Betonpumpe und Fahrmischer auf Baustelle',
    caption: 'Koordinierter Ablauf mit Fahrmischer',
    category: 'betontransport',
  },
  {
    id: 9,
    src: '/assets/img/reference-09.webp',
    srcSet: '/assets/img/reference-09-700.webp 700w, /assets/img/reference-09-1000.webp 1000w, /assets/img/reference-09.webp 1400w',
    alt: 'Großbaustelle mit Betonpumpe in Wien',
    caption: 'Baustelle im Wiener Stadtgebiet',
    category: 'betontransport',
  },
  {
    id: 10,
    src: '/assets/img/reference-10.webp',
    srcSet: '/assets/img/reference-10-700.webp 700w, /assets/img/reference-10.webp 1050w',
    alt: 'Betonpumpe und Fahrmischer auf Erdbau-Baustelle',
    caption: 'Transport und Pumpe abgestimmt',
    category: 'betontransport',
  },
  {
    id: 11,
    src: '/assets/img/reference-11.webp',
    srcSet: '/assets/img/reference-11-700.webp 700w, /assets/img/reference-11-1000.webp 1000w, /assets/img/reference-11.webp 1050w',
    alt: 'Betonpumpe mit ausgefahrenem Mast in einer Wohnstraße',
    caption: 'Flexible Einbringung in Wien und Umgebung',
    category: 'betonpumpe',
  },
  {
    id: 12,
    src: '/assets/img/reference-12.webp',
    srcSet: '/assets/img/reference-12-700.webp 700w, /assets/img/reference-12.webp 1050w',
    alt: 'Betonpumpenfahrzeug mit zusammengelegtem Mast',
    caption: 'Bereit für den nächsten Einsatz',
    category: 'betonpumpe',
  },
  {
    id: 13,
    src: '/assets/img/reference-13.webp',
    srcSet: '/assets/img/reference-13-700.webp 700w, /assets/img/reference-13.webp 1050w',
    alt: 'Betonpumpe über Baugrube mit Schalung',
    caption: 'Einbringung über die Baugrube',
    category: 'betonpumpe',
  },
];

export const categories = [
  { value: 'all', label: 'Alle' },
  { value: 'betonpumpe', label: 'Betonpumpe' },
  { value: 'betontransport', label: 'Betontransport' },
  { value: 'betonverkauf', label: 'Betonverkauf' },
];
